import { Slide, type SlideProps } from '@mui/material';
import { forwardRef } from 'react';

export const SlideUpTransition = forwardRef(function Transition(
  props: SlideProps,
  ref
) {
  return <Slide direction='up' ref={ref} {...props} />;
});
